module.exports = __webpack_public_path__ + "img/logo.152d2170.svg";